import React from "react";
import { RadioGroup, RadioGroupItem, Switch } from "@panda0/panda0-ui";
import { Settings } from "lucide-react";
import { Controller, useFormContext } from "react-hook-form";

import { FormData, SHARE_RESULTS_OPTIONS } from "../types";

const QuizSettingsEditor: React.FC = () => {
  const { control, watch } = useFormContext<FormData>();
  const quizSettings = watch("quizSettings");
  const [enabled, setEnabled] = React.useState(true);

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">
        Configure settings for the panda quiz.
      </p>

      <div className="flex items-center justify-between mb-4">
        <label className="font-medium">Customize Quiz Configuration</label>
        <Switch checked={enabled} fn={setEnabled} />
      </div>

      {enabled && (
        <div className="space-y-4">
          <div className="p-4 border rounded-md bg-gray-50">
            <div className="flex items-center mb-4">
              <Settings className="h-5 w-5 mr-2 text-primary" />
              <h3 className="font-medium">Quiz Configuration</h3>
            </div>

            <div className="space-y-4">
              <div className="space-y-2">
                <label className="block text-sm font-medium">
                  Share Results with Candidate
                </label>
                <Controller
                  name="quizSettings.QUIZ_SHARERESULTS"
                  control={control}
                  render={({ field }) => (
                    <RadioGroup
                      value={field.value || "NEVER"}
                      onValueChange={(value) => field.onChange(value)}
                    >
                      {SHARE_RESULTS_OPTIONS.map((option) => (
                        <div
                          key={option.value}
                          className="flex items-center space-x-2"
                        >
                          <RadioGroupItem
                            value={option.value}
                            id={`share-${option.value}`}
                          />
                          <label
                            htmlFor={`share-${option.value}`}
                            className="text-sm"
                          >
                            {option.label}
                          </label>
                        </div>
                      ))}
                    </RadioGroup>
                  )}
                />
              </div>
            </div>
            <div className="mt-2">
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <label className="text-sm font-medium">
                    Email Confirmation to Candidate
                  </label>
                  <Controller
                    name="submissionSettings.QUIZSUBMISSION_EMAIL_CONFIRMATION"
                    control={control}
                    render={({ field }) => (
                      <Switch
                        checked={field.value || false}
                        fn={(checked) => field.onChange(checked)}
                      />
                    )}
                  />
                </div>
                <div className="flex items-center justify-between">
                  <label className="text-sm font-medium">
                    Enable Quiz Gameplay
                  </label>
                  <Controller
                    name="submissionSettings.QUIZ_GAME_PLAY"
                    control={control}
                    render={({ field }) => (
                      <Switch
                        checked={field.value || false}
                        fn={(checked) => field.onChange(checked)}
                      />
                    )}
                  />
                </div>
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <label className="text-sm font-medium">
                      Notify Hiring Team
                    </label>
                    <Controller
                      name="submissionSettings.QUIZSUBMISSION_NOTIFY_HIRING_TEAM"
                      control={control}
                      render={({ field }) => (
                        <Switch
                          checked={field.value || false}
                          fn={(checked) => field.onChange(checked)}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(QuizSettingsEditor);
